<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Countries/elements/Title.vue'

export default {
  name: 'CountryForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>

<style scoped>

</style>
